module.exports = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./static/fancybox/blank.gif
 ** module id = 600
 ** module chunks = 2
 **/